(function () {
  'use strict';

  /* @ngdoc object
   * @name tracker
   * @description
   *
   */
  angular
    .module('tracker', [
      'ui.router'
    ]);
}());
